var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gl-scroll-scrim gl-overflow-auto",class:_vm.scrimClasses},[_vm._m(0),_vm._v(" "),_c('div',{ref:"top-boundary"}),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('div',{ref:"bottom-boundary"}),_vm._v(" "),_vm._m(1)],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-scrim-wrapper"},[_c('div',{staticClass:"top-scrim"})])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom-scrim-wrapper"},[_c('div',{staticClass:"bottom-scrim"})])
}]

export { render, staticRenderFns }